import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AssessmentSettings, AssessmentCriteria, Course } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { CurrentContextService } from '@shared/services/currentContextService';

@Component({
  selector: 'assessment-edit-dialog',
  templateUrl: './assessment-edit-dialog.component.html',
  styleUrls: ['./assessment-edit-dialog.component.scss']
})
export class AssessmentEditDialogComponent implements OnInit {
  assessmentForm: FormGroup;
  course: Course;
  assessment: AssessmentSettings;
  MIN_CRITERIA = 3;
  MAX_CRITERIA = 10;

  constructor(
    public _dialogRef: MatDialogRef<AssessmentEditDialogComponent>,
    private _courseApiService: CoursesAPIService,
    private _CurrentContextService: CurrentContextService,
    private _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public _data: { course: Course, childrenClass: string }
  ) {
  }

  ngOnInit(): void {
    this.assessment = this._data.course.information?.assessment || new AssessmentSettings(
      '', 
      '', [
        new AssessmentCriteria(0, 'Criteria', ''),
        new AssessmentCriteria(1, 'Criteria', ''),
        new AssessmentCriteria(2, 'Criteria', ''),
      ]
    );
    this.assessmentForm = new FormGroup({
      title: new FormControl(''),
      description: new FormControl(''),
      criterias: new FormControl<AssessmentCriteria>(null)
    });
    this.assessment = JSON.parse(JSON.stringify(this.assessment));
    this.assessmentForm.reset(this.assessment, { emitEvent: false });
  }

  addCriteria(): void {
    const newId = this.assessment.criterias.length === 0 ? 0 :
      1 + this.assessment.criterias
        .map(c => c.id)
        .reduce((a, b) => Math.max(a, b))
    this.assessment.criterias.push(new AssessmentCriteria(newId, 'Criteria', ''));
    this.assessmentForm.controls.criterias.setValue(this.assessment.criterias);
  }

  updateCriteria(event: any): void {
    const criteria = event as AssessmentCriteria;
    const index = this.assessment.criterias.findIndex(c => c.id === criteria.id);
    this.assessment.criterias[index] = criteria;
  }

  deleteCriteria(event: any): void {
    const criteriaId = event as number;
    const index = this.assessment.criterias.findIndex(c => c.id === criteriaId);
    this.assessment.criterias.splice(index, 1);
  }

  saveAndClose(): void {
    const assessment = { ...this.assessment, ...this.assessmentForm.value };
    const information = {
      ...this._data.course.information,
      assessment
    };

    this._courseApiService.updateCourse(this._data.course.id, { information }, true).subscribe(c => {
      this._data.course.information = information;
      this._dialogRef.close(c);
    });
  }
}
